




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import printHeader from './PrintHeader.vue';
import printFooter from './PrintFooter.vue';
import {
    RelazionePrintDialogViewModel,
    Prestazione,
    RelazioneMedica
} from '../../types';
import * as exportService from '@/services/common/export-service';

export default Vue.extend({
    components: { printHeader, printFooter },
    props: {
        item: { required: true },
        show: { default: false }
    },
    data(): RelazionePrintDialogViewModel {
        return {
            isOpen: false,
            hideItems: false
        };
    },
    methods: {
        close() {
            this.isOpen = false;
            this.$emit('close');
        },
        print(withoutRelatore: boolean) {
            if (!this.item) {
                return;
            }
            this.hideItems = withoutRelatore;

            setTimeout(() => {
                exportService.exportToPDF(
                    document.getElementById('relazionePrint') as HTMLElement,
                    {
                        fileName: ((this.item as RelazioneMedica)
                            .prestazione as Prestazione).displayName,
                        margin: { left: 20, top: 20, right: 20 },
                        paperSize: 'A4',
                        scale: 0.5,
                        forcePageBreak: '.page-break'
                    }
                );
            }, 500);
        },
        isNullOrEmpty(value: string) {
            return !value || value.trim().length === 0;
        }
    },
    watch: {
        show: {
            handler: function(val) {
                this.isOpen = val;
            }
        }
    }
});
